import { PhoneConfirmationAbstractComponent } from '@app/+login/deprecated-hybrid/views/phone-confirmation/phone-confirmation.abstract.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LoginV2CommonService } from '@app/+login/deprecated-hybrid/login-v2-common.service';
import { SettingsService } from '@app/core/settings/settings.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MsisdnInputComponent } from '@app/shared/components/msisdn-input/msisdn-input.component';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { FormsModule } from '@angular/forms';
import { HYBRID_AUTH_PATH, HYBRID_REGISTER_PATH } from '@app/+login/consts';
import { PageTitleComponent } from '@app/+login/deprecated-hybrid/components/page-title/page-title.component';

const UNREGISTERED_IDENTIFIER_ERROR_KEY = 'phone_number_unregistered';

@Component({
  selector: 'app-login-phone-confirmation',
  templateUrl: '../phone-confirmation.component.html',
  styleUrls: ['../phone-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    MsisdnInputComponent,
    InputErrorsComponent,
    RouterLink,
    FormsModule,
    PageTitleComponent,
  ],
})
export class LoginPhoneConfirmationComponent extends PhoneConfirmationAbstractComponent {
  public otherMethodKey = 'sessions.new.register_url';
  public headerTitleKey = 'login.title';
  public pageType: 'login' | 'signup' = 'login';

  // for some reason it does not recognize protected constructor in parent class
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(router: Router, route: ActivatedRoute, common: LoginV2CommonService,
              settingsService: SettingsService, cdr: ChangeDetectorRef) {
    super(router, route, common, settingsService, cdr);
  }

  public onNext(): void {
    const identifier = this.currentMsisdnIdentifier();

    this.common.checkMemberPublicInfo(
      identifier,
      (publicInfo) => this.common.navigateToAuthPage(['..', HYBRID_AUTH_PATH], identifier, this.route, publicInfo),
      () => this.setFormControlError(UNREGISTERED_IDENTIFIER_ERROR_KEY),
    );
  }

  public navigateToOtherMethod(): void {
    this.router.navigate(['..', HYBRID_REGISTER_PATH], {
      state: { identifierValue: `+${this.formControl.value}` },
      relativeTo: this.route,
    });
  }
}
